import { toast } from '@ixigo/iui/toast';

// CBCC failure nudge: an error toast shown when a CBCC API call fails (the hooks
// fire this from their catch blocks). We deliberately do NOT pin a position
// here — the toast inherits whichever <Toaster> is mounted (travel-credit-card
// layout + apply page), which sets position PER DEVICE: bottom-center on mweb,
// bottom-right on web. In react-hot-toast a per-toast `position` OVERRIDES the
// Toaster's, so omitting it is exactly what lets the device-driven Toaster
// position win.
//
// Both are BOTTOM positions, so iui's built-in enter slides the toast UP from
// below (the top-position variant slid down — which mismatched the old top-right
// placement); the whole nudge (not just its text) animates as one.
const DEFAULT_MESSAGE = 'Something went wrong, please try again';

/**
 * Show the CBCC API-failure nudge (slides up from below; bottom-center on mweb,
 * bottom-right on web — position comes from the mounted Toaster). Pass a custom
 * message for flows that have a more specific one; otherwise the generic retry
 * copy is used. Safe to call from any catch block.
 */
export function showCbccErrorToast(message: string = DEFAULT_MESSAGE): void {
	toast.error(message);
}
